import { Container, Matrix, Rectangle, Renderer } from "pixi.js"

/** A room-wide filter needs the render view, not the bounds of every tree in the room. */
export class ViewFilteredContainer extends Container {
    private viewArea = new Rectangle()
    private inverseProjection = new Matrix()

    protected renderAdvanced(renderer: Renderer): void {
        const previousArea = this.filterArea
        if (!previousArea && this.filters?.some(filter => filter.enabled)) {
            const area = this.viewArea.copyFrom(renderer.renderTexture.sourceFrame)
            // FilterSystem expects global coordinates before the optional render projection.
            // Read the current target here so resize, nested filters and PiP renders all work.
            const projection = renderer.projection.transform
            if (projection) {
                const matrix = this.inverseProjection.copyFrom(projection).invert()
                const left = area.x, top = area.y, right = area.right, bottom = area.bottom
                const x1 = matrix.a * left + matrix.c * top + matrix.tx
                const x2 = matrix.a * right + matrix.c * top + matrix.tx
                const x3 = matrix.a * left + matrix.c * bottom + matrix.tx
                const x4 = matrix.a * right + matrix.c * bottom + matrix.tx
                const y1 = matrix.b * left + matrix.d * top + matrix.ty
                const y2 = matrix.b * right + matrix.d * top + matrix.ty
                const y3 = matrix.b * left + matrix.d * bottom + matrix.ty
                const y4 = matrix.b * right + matrix.d * bottom + matrix.ty
                area.x = Math.min(x1, x2, x3, x4)
                area.y = Math.min(y1, y2, y3, y4)
                area.width = Math.max(x1, x2, x3, x4) - area.x
                area.height = Math.max(y1, y2, y3, y4) - area.y
            }
            this.filterArea = area
        }
        try {
            super.renderAdvanced(renderer)
        } finally {
            // Do not constrain bounds queries outside this draw (occlusion and hit testing).
            this.filterArea = previousArea
        }
    }
}
